import { DOMUtils } from '../../../../utils/dom'
import { IIdentityFormFields } from '../adapter'
import { IAPIError, IErrorType } from './base'

export class IdentityFormUtils {
    private static DOM = {
        errorList: 'errorlist',
        identityFormErrorMessage: 'identity-form__message--error',
        inputErrorMessage: 'form-container__message--error',
        inputWrapperError: 'form-container__field--error',
    }

    /**
     * Returns form fields as a key value pair JSON
     *
     * @return {IIdentityFormFields}
     */
    public static getFields(): IIdentityFormFields {
        let data = [] as IIdentityFormFields

        const form = document.querySelector(`[data-id-form]`)

        if (form) {
            const fields = form.querySelectorAll<HTMLInputElement | HTMLSelectElement>(
                'input:not([type=hidden]), select'
            )

            fields.forEach((field) => {
                // convert key to camel case
                const key = (field.name).replace(/[_][a-z1-9]/g, (group) => group.slice(-1).toUpperCase())

                // key value pair
                data = { ...data, [key]: field.value}
            })
        }
        return data
    }

    /**
     * Convert incoming fetch error to the list of errors.
     * @param errorObject
     */
    public static structureErrors(errorObject: IAPIError): IErrorType[] {
        let errors: IErrorType[] = []
        if (errorObject.json) {
            errors = Object.entries(errorObject.json).map(
                ([key, messages]: [string, ReadonlyArray<string>]) => ({ key, message: messages[0] })
            )
        } else {
            errors = [{
                key: 'non_field_errors',
                message: `Error: ${errorObject.statusText}. Please try again later.`,
            }]
        }
        return errors
    }

    public static clearErrors() {
        const errorMsg = document.querySelector(`.${IdentityFormUtils.DOM.identityFormErrorMessage}`)
        if (errorMsg) {
            errorMsg.remove()
        }

        // clear input errors
        const inputErrorWrappers = document.querySelectorAll(`.${IdentityFormUtils.DOM.inputWrapperError}`)

        inputErrorWrappers.forEach((inputErrorWrapper) => {
            const inputField = inputErrorWrapper.querySelector('input')
            const inputError = inputErrorWrapper.querySelector(`.${IdentityFormUtils.DOM.inputErrorMessage}`)

            DOMUtils.removeClass(inputErrorWrapper, `${IdentityFormUtils.DOM.inputWrapperError}`)

            if (inputField) {
                inputField.removeAttribute('aria-describedby')
                inputField.removeAttribute('aria-invalid')
            }

            if (inputError) {
                inputError.remove()
            }
        })
    }

    /**
     * Show global, non field specific errors
     *
     * @param formSelector
     * @param errors
     */
    public static showErrors(formSelector: string, errors: Array<{key: string, message: string}>) {
        errors.forEach((error) => {
            if (error.key === 'non_field_errors') {
                IdentityFormUtils._showNonFieldError(formSelector, error.message)
            } else {
                IdentityFormUtils._showFieldError(error.key, error.message)
            }
        })
    }

    /**
     * Show global, non field specific errors
     *
     * @param formSelector
     * @param errorMessage
     */
    public static _showNonFieldError(formSelector: string, errorMessage: string) {
        const formControls = document.querySelector(formSelector)
        const errorDiv = document.createElement('div')
        const errorList = document.createElement('ul')
        const errorListItem = document.createElement('li')

        errorDiv.className = IdentityFormUtils.DOM.identityFormErrorMessage
        errorDiv.setAttribute('role', 'alert')

        errorList.className = IdentityFormUtils.DOM.errorList

        errorListItem.innerHTML = errorMessage

        errorList.appendChild(errorListItem)
        errorDiv.appendChild(errorList)

        if (formControls) {
            formControls.after(errorDiv)
        }
    }

    public static _showFieldError(fieldName: string, errorMessage: string) {
        const inputField = document.querySelector(`#id_${fieldName}`)
        const inputErrorSpan = document.createElement('span')
        const inputErrorList = document.createElement('ul')
        const errorListItem = document.createElement('li')
        const errorMessageId = `id_${fieldName}__error`
        if(inputField) {
            let ariaDescribedBy = inputField.getAttribute('aria-describedBy')

            if (!ariaDescribedBy) {
                ariaDescribedBy = `${errorMessageId}`
            }

            inputField.setAttribute('aria-describedBy', ariaDescribedBy)
            inputField.setAttribute('aria-invalid', 'true')
            inputErrorSpan.id = errorMessageId
            errorListItem.innerHTML = errorMessage

            // Error field styling classes
            DOMUtils.addClass(inputErrorSpan,  IdentityFormUtils.DOM.inputErrorMessage)
            DOMUtils.addClass(inputErrorList, 'errorlist')

            // Add validation error
            const inputWrapper = inputField.parentElement
            DOMUtils.addClass(inputWrapper, IdentityFormUtils.DOM.inputWrapperError)
            inputErrorList.appendChild(errorListItem)
            inputErrorSpan.appendChild(inputErrorList)
            inputWrapper.appendChild(inputErrorSpan)
        }
    }
}
